import React from "react";
import { RichTextEditorMenuButtonProps } from "@/modules/hub/features/ResourceManagement/components/RichTextEditorMenuButton/types";

export function RichTextEditorMenuButton({
  onClick,
  isActive = false,
  children,
  title,
}: RichTextEditorMenuButtonProps) {
  return (
    <button
      aria-pressed={isActive}
      className={`p-2 text-sm font-medium rounded hover:bg-blue-100 dark:hover:bg-slate-700 ${
        isActive ? "bg-blue-100 dark:bg-slate-700 text-blue-700 dark:text-blue-400" : "text-gray-900 dark:text-gray-300"
      }`}
      onClick={onClick}
      title={title}
      type="button"
    >
      {children}
    </button>
  );
}
